import { TermsAndConditions } from "../../../jsx/components/Dashboard/TermsAndConditions";

const HomeWrapper = () => {
  return <TermsAndConditions />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.customer];
export default constore(HomeWrapper);
